/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetMarketMakerRebatesOptions,
  GetMarketMakerRebatesStatus200,
  GetMarketMakerRebatesStatus400,
  GetMarketMakerRebatesStatus401,
  GetMarketMakerRebatesStatus403,
  GetMarketMakerRebatesStatus404,
  GetMarketMakerRebatesStatus409,
  GetMarketMakerRebatesStatus500,
} from '../types/GetMarketMakerRebates'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getMarketMakerRebates } from '../clients/getMarketMakerRebates'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getMarketMakerRebatesQueryKey = ({
  path,
}: Omit<GetMarketMakerRebatesOptions, 'headers'>) =>
  [{ url: '/v1/market-makers/:market_maker_id/rebates', params: path }] as const

type GetMarketMakerRebatesQueryKey = ReturnType<typeof getMarketMakerRebatesQueryKey>

export function getMarketMakerRebatesQueryOptions(
  { path }: GetMarketMakerRebatesOptions,
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getMarketMakerRebatesQueryKey({ path })
  return queryOptions<
    GetMarketMakerRebatesStatus200,
    ResponseErrorConfig<
      | GetMarketMakerRebatesStatus400
      | GetMarketMakerRebatesStatus401
      | GetMarketMakerRebatesStatus403
      | GetMarketMakerRebatesStatus404
      | GetMarketMakerRebatesStatus409
      | GetMarketMakerRebatesStatus500
    >,
    GetMarketMakerRebatesStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getMarketMakerRebates({
        ...config,
        path,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @description Admin only. All percentages are fractions in [0,1].
 * @summary Get rebate configuration
 * {@link /v1/market-makers/:market_maker_id/rebates}
 */
export function useGetMarketMakerRebates<
  TData = GetMarketMakerRebatesStatus200,
  TQueryData = GetMarketMakerRebatesStatus200,
  TQueryKey extends QueryKey = GetMarketMakerRebatesQueryKey,
>(
  {
    path,
  }: { path: GetMarketMakerRebatesOptions['path'] | (() => GetMarketMakerRebatesOptions['path']) },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetMarketMakerRebatesStatus200,
        ResponseErrorConfig<
          | GetMarketMakerRebatesStatus400
          | GetMarketMakerRebatesStatus401
          | GetMarketMakerRebatesStatus403
          | GetMarketMakerRebatesStatus404
          | GetMarketMakerRebatesStatus409
          | GetMarketMakerRebatesStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path }
  const queryKey = resolvedOptions?.queryKey ?? getMarketMakerRebatesQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getMarketMakerRebatesQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetMarketMakerRebatesStatus400
      | GetMarketMakerRebatesStatus401
      | GetMarketMakerRebatesStatus403
      | GetMarketMakerRebatesStatus404
      | GetMarketMakerRebatesStatus409
      | GetMarketMakerRebatesStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
